const config = {
  apiBaseUrl: process.env.REACT_APP_API_URL || 
    (process.env.NODE_ENV === 'production' 
      ? "https://notifyhubspi.terasite.com" 
      : "https://localhost:7198"),
  
  // Site Page Info API Configuration https://localhost:7198
  sitePageInfoApi: {
    baseUrl: process.env.REACT_APP_SITE_PAGE_API_URL || 'https://contentreader.terasite.com',
    siteId: process.env.REACT_APP_SITE_ID || '88',
    endpoint: '/api/SitePageInfo/getDetailsList'
  }
};

// Helper function to build site page info API URLs
export const buildSitePageInfoUrl = (pageType: string) => {
  const url = new URL(config.sitePageInfoApi.endpoint, config.sitePageInfoApi.baseUrl);
  url.searchParams.append('pageType', pageType);
  return url.toString();
};

// Helper function to get site page info headers
export const getSitePageInfoHeaders = () => ({
  'Content-Type': 'application/json',
  'X-SiteId': config.sitePageInfoApi.siteId
});

export default config;
